import { ErrorBoundary } from '@ets/design-system';

import styles from './PDFPageFallback.module.scss';
import { CSSProperties, ReactNode } from 'react';

export type PDFPageFallbackProps = {
  scale: CSSProperties['scale'];
  children: ReactNode;
};

const PDFPageFallback = ({ scale, children }: PDFPageFallbackProps) => {
  return (
    <div className={styles.root}>
      <ErrorBoundary size="l" style={{ scale: `${scale}` }}>
        {children}
      </ErrorBoundary>
    </div>
  );
};

export default PDFPageFallback;
